import React from 'react';
import { List, Datagrid, TextField, EditButton } from 'react-admin';
import ListActions from './actions';
import { Pagination } from '../../Components';
import LocationFilters from './filters';

const LocationList = (props) => (
  <List
    bulkActionButtons={false}
    actions={<ListActions />} 
    filters={<LocationFilters />}
    {...props}
    perPage={50}
    pagination={<Pagination />}
  >
    <Datagrid>
      <TextField source="name" label="Location name" sortable={false} />
      <TextField source="city" sortable={false} />
      <EditButton />
    </Datagrid>
  </List>
);

export default LocationList;
